import { takeLeading } from "@redux-saga/core/effects";

import { AuthActionTypes } from "../types";
import { initUserSaga } from "./initUserSaga";
import { migrateUserSaga } from "./migrateGuestSaga";
import { getCurrentUserSaga } from "./getCurrentUserSaga";

export default function* authSaga() {
    yield takeLeading(AuthActionTypes.INIT_USER_REQUEST, initUserSaga);
    yield takeLeading(AuthActionTypes.MIGRATE_GUEST_TO_USER_REQUEST, migrateUserSaga);
    yield takeLeading(AuthActionTypes.GET_CURRENT_USER_REQUEST, getCurrentUserSaga);
}
